import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { PartialReferenceFormRequest, Reference, ReorderReferencesResponse } from '../interfaces/Reference';

export async function getReferences(params?: { programId?: string; keyword?: string; }): Promise<StandardResponse<Reference[]>> {
    const response: AxiosResponse<StandardResponse<Reference[]>> = await api.get("/references", {
        params
    });
    return response.data;
}

export async function getReferenceById(referenceId: string): Promise<StandardResponse<Reference>> {
    const response: AxiosResponse<StandardResponse<Reference>> = await api.get(`/references/${referenceId}`);
    return response.data;
}

export async function createReference(request: PartialReferenceFormRequest): Promise<StandardResponse<Reference>> {
    const response: AxiosResponse<StandardResponse<Reference>> = await api.post("/references", request);
    return response.data;
}

export async function updateReference(referenceId: string, request: PartialReferenceFormRequest): Promise<StandardResponse<Reference>> {
    const response: AxiosResponse<StandardResponse<Reference>> = await api.put(`/references/${referenceId}`, request);
    return response.data;
}

export async function deleteReference(referenceId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/references/${referenceId}`);
    return response.data;
}

export async function reorderReferences(request: { programId: string; references: string[]; }): Promise<StandardResponse<ReorderReferencesResponse>> {
    const response: AxiosResponse<StandardResponse<ReorderReferencesResponse>> = await api.post("/references/sequence", request);
    return response.data;
}
